import { CheckCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface CompletionScreenProps {
  jobTitle: string;
}

export function CompletionScreen({ jobTitle }: CompletionScreenProps): React.ReactNode {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm">
        <div className="rounded-2xl border border-border bg-card px-8 py-10 shadow-sm">
          <div className="flex flex-col items-center gap-4 text-center">
            <div className="flex size-14 items-center justify-center rounded-full bg-green-100">
              <CheckCircle className="size-7 text-green-600" />
            </div>
            <h1 className="text-xl">{t('screening.completed.title')}</h1>
            <p className="text-sm leading-relaxed text-muted-foreground">
              {t('screening.completed.message', { jobTitle })}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
